module.exports = __webpack_public_path__ + "img/wxBanner.b04def09.png";